import { render } from "./inward-stock.vue?vue&type=template&id=031d7f86"
import script from "./inward-stock.vue?vue&type=script&lang=js"
export * from "./inward-stock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__